
export default {
	name: "NormalPage",
	data() {
		return {
			font: "Mutator Sans"
		}
	},
	created() {
	},
	computed: {
		pageUrl: function () {
			return location.href;
		}
	},
	mounted() {
		this.divScale();
	},
	methods: {
		divScale() {
			let inputWeight = document.getElementById("input-weight");
			let inputWidth = document.getElementById("input-width");
			let logo = document.getElementById("logo-scale");

			window.addEventListener("mousemove", () => {
				logo.style.width = inputWidth.value + 'vw'

				let logoHeight = logo.clientHeight
				let logoWidth = logo.clientWidth;
				
				function logoValue(children, key, value ) {
					if(children.length) {
						children.forEach(element => {
							if(key == "style.marginRight")
								logo.children[element].style.marginRight = value[element];
							
							if( key == "innerHTML" )
								logo.children[element].innerHTML = value[element];
						});
					}
				}

				let width = logoWidth / 2;
				let weight = inputWeight.value;
				
				if( logoWidth > 1200 ) {
					logoValue([0, 1, 2], "innerHTML", ["Porto", "Design", "Biennale"] )
					logoValue([0, 1, 2], "style.marginRight", ["2rem", "2rem", "2rem"])
				}
				if( logoWidth < 1200) {
					logoValue([0, 1, 2], "innerHTML", ["Porto", "Design", "B"] )
					logoValue([0, 1, 2], "style.marginRight", ["2rem", "2rem", "2rem"])
					width = logoWidth + 50;
				}
				
				if( logoWidth < 800 ) {
					logoValue([0, 1, 2], "innerHTML", ["Porto", "D", "B"] )
					logoValue([0, 1, 2], "style.marginRight", ["2rem", "2rem", "2rem"])
					width = logoWidth + 200;
				}
				
				if( logoWidth < 400 ) {
					logoValue([0, 1, 2], "innerHTML", ["P", "D", "B"] )
					logoValue([0, 1, 2], "style.marginRight", [0, 0, 0])
					
					width = logoWidth * 2;
					weight = inputWeight.value * 2;
				}
				
				
				logo.style.fontVariationSettings = `"wght" ${weight}, "wdth" ${width} `;
				
			})

		}
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/scale/scale.page.js